module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-01.4af26ba4.jpg";